








































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateLocationTypeRequest from '@/models/LocationTypes/CreateLocationTypeRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'LocationTypeCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new CreateLocationTypeRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateLocationTypeRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
       
    await AgencySettingsModule.createLocationType(this.entity)
    this.dialog = false;
  }
}
